import { createFileRoute, redirect } from '@tanstack/react-router';
import type { RecoveryRenewalsSearch } from '@/components/organisms/recovery-renewals/recovery-renewals-model';

type LegacySearch = RecoveryRenewalsSearch & { tab?: 'recovery' | 'renewals' };

/**
 * NOT-567 — the combined "Recovery & Renewals" workspace was split into the
 * Past due page (dunning) and a Renewals tab on the Memberships page. This old
 * route redirects to whichever half the deep link was aimed at, preserving the
 * queue state so bookmarks and notification links keep working.
 */
export const Route = createFileRoute('/_dashboard/dashboard/recovery-renewals')({
  validateSearch: (search: Record<string, unknown>): LegacySearch => ({
    tab:
      search.tab === 'renewals' ? 'renewals' : search.tab === 'recovery' ? 'recovery' : undefined,
    q: typeof search.q === 'string' ? search.q : '',
    type:
      search.type === 'JOB' || search.type === 'MEMBERSHIP'
        ? (search.type as RecoveryRenewalsSearch['type'])
        : 'ALL',
    status:
      search.status === 'ACTIVE' || search.status === 'PAST_DUE' || search.status === 'SUSPENDED'
        ? (search.status as RecoveryRenewalsSearch['status'])
        : 'ALL',
    renewalFilter:
      search.renewalFilter === 'DUE_THIS_WEEK' ||
      search.renewalFilter === 'OVERDUE_NOTICE' ||
      search.renewalFilter === 'AUTO_RENEW_OFF'
        ? (search.renewalFilter as RecoveryRenewalsSearch['renewalFilter'])
        : 'ALL',
    page:
      typeof search.page === 'number' && Number.isFinite(search.page) && search.page > 0
        ? Math.floor(search.page)
        : 1,
  }),
  beforeLoad: ({ search }) => {
    if (search.tab === 'renewals') {
      throw redirect({
        to: '/dashboard/memberships',
        search: {
          q: '',
          status: 'all',
          source: 'all',
          queue: 'all',
          page: 1,
          sort: 0,
          view: 'renewals',
        },
      });
    }
    // Preserve the recovery/dunning queue state on the way to Past due.
    throw redirect({
      to: '/dashboard/past-due',
      search: {
        q: search.q,
        type: search.type,
        status: search.status,
        renewalFilter: 'ALL',
        page: search.page,
      },
    });
  },
});
